import React from "react";
import { filterRoutes } from "@/utils/featureFlipDependepent";
import MeetingList from "@pages/interviews/pages/MeetingList";
import CreateMeeting from "@pages/interviews/pages/CreateMeeting";
import MeetingDetails from "@pages/interviews/components/Meeting/MeetingDetails";
import CompanyInvoices from "@pages/business/invoices/CompanyInvoices";
import InvoiceDetails from "@pages/business/invoices/InvoiceDetails";
import PaymentPage from "@pages/business/invoices/PaymentPage";
import BIAnalysisPage from "@pages/bi_b2b";

const AISurvey = React.lazy(() => import("@pages/survey/new/ai/index"));
const CreateSurveyFromScratch = React.lazy(() =>
  import("@pages/survey/new/scratch/index")
);
const SurveyCreationMethod = React.lazy(() =>
  import("@pages/survey/new/index")
);
const SurveyAnalyticsPage  = React.lazy(() =>
  import("@pages/survey/surveyId/SurveyAnalyticsPage")
);
// const CreateSimpleSurvey = React.lazy(() =>
//   import("@pages/survey/new/simple/index")
// );
const Reports = React.lazy(() =>
  import("@pages/reports")
);
const FocusGroupNew = React.lazy(() =>
  import("@pages/focus-group/focusGroup/new")
);
const SurveySeeder = React.lazy(() =>
  import("@pages/survey/seeder/SurveySeederButton")
);
const SurveyThankYou = React.lazy(() => import("@pages/public/surveys/PublicSurveyThankYou"));

export const businessRoutes = filterRoutes([
  { path: "/survey/new", element: <SurveyCreationMethod /> },
  { path: "/factures", element: <CompanyInvoices  /> },
  { path: "/factures/:id", element: <InvoiceDetails   /> },
  { path: "/factures/:id/paiement", element: <PaymentPage    /> },
  {
    path: "/survey/:surveyId/edit/:stepName",
    element: <CreateSurveyFromScratch isEditing={true} />,
  },
  { path: "/survey/:surveyId/analytics", element: <SurveyAnalyticsPage /> },
  { path: "/survey/new/scratch", element: <CreateSurveyFromScratch /> },
  { path: "/survey/new/simple", element: <SurveySeeder /> },
  // { path: "/survey/new/simple", element: <CreateSimpleSurvey /> },
  { path: "/survey/new/ai", element: <AISurvey /> },
  { path: "/interviews", element: <MeetingList /> },
  { path: "/interviews/create", element: <CreateMeeting /> },
  { path: "/interviews/:id", element: <MeetingDetails /> },
  { path: "/focus-group/new", element: <FocusGroupNew/> },
  { path: "/reports", element: <Reports/> },
  { path: "/BI/Dashboard", element: <BIAnalysisPage/> },
  {
    caseSensitive: true,
    path: "/survey/:surveyId/completion",
    element: <SurveyThankYou />,
  }
], "business");
